var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 6.09375C0.25 2.72812 2.97812 0 6.34375 0C9.70938 0 12.4375 2.72812 12.4375 6.09375C12.4375 9.45938 9.70938 12.1875 6.34375 12.1875C2.97812 12.1875 0.25 9.45938 0.25 6.09375ZM6.34375 3.75C6.46807 3.75 6.5873 3.79939 6.67521 3.88729C6.76311 3.9752 6.8125 4.09443 6.8125 4.21875V6.5625C6.8125 6.68682 6.76311 6.80605 6.67521 6.89396C6.5873 6.98186 6.46807 7.03125 6.34375 7.03125C6.21943 7.03125 6.1002 6.98186 6.01229 6.89396C5.92439 6.80605 5.875 6.68682 5.875 6.5625V4.21875C5.875 4.09443 5.92439 3.9752 6.01229 3.88729C6.1002 3.79939 6.21943 3.75 6.34375 3.75ZM6.34375 8.90625C6.46807 8.90625 6.5873 8.85686 6.67521 8.76896C6.76311 8.68105 6.8125 8.56182 6.8125 8.4375C6.8125 8.31318 6.76311 8.19395 6.67521 8.10604C6.5873 8.01814 6.46807 7.96875 6.34375 7.96875C6.21943 7.96875 6.1002 8.01814 6.01229 8.10604C5.92439 8.19395 5.875 8.31318 5.875 8.4375C5.875 8.56182 5.92439 8.68105 6.01229 8.76896C6.1002 8.85686 6.21943 8.90625 6.34375 8.90625Z",
    fill: "#FFB240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.65573767cdd09a6d907e6e03170ff04f.svg";
export { ForwardRef as ReactComponent };